"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppModel = void 0;
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var BackendModel_1 = require("./BackendModel");
var app_1 = require("firebase/app");
var remote_config_1 = require("firebase/remote-config");
var utils_1 = require("@dp-instant/utils");
var AppModel = (function (_super) {
    tslib_1.__extends(AppModel, _super);
    function AppModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppModel.prototype.init = function (config) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var firebaseConfig, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (process.env.NODE_ENV === "development") {
                            window.app = this;
                        }
                        firebaseConfig = config.firebase;
                        this._firebaseApp = (0, app_1.initializeApp)(firebaseConfig);
                        this._remoteConfig = (0, remote_config_1.getRemoteConfig)();
                        this._remoteConfig.defaultConfig = this.getDefaultRemoteConfig(config.host);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4, (0, remote_config_1.ensureInitialized)(this._remoteConfig).catch(utils_1.log.warn)];
                    case 2:
                        _a.sent();
                        return [4, (0, remote_config_1.fetchAndActivate)(this._remoteConfig).catch(utils_1.log.warn)];
                    case 3:
                        _a.sent();
                        return [3, 5];
                    case 4:
                        e_1 = _a.sent();
                        utils_1.log.warn("Failed to activate remote config", e_1);
                        return [3, 5];
                    case 5:
                        this._defaultPayload || (this._defaultPayload = {});
                        this._defaultPayload.app_id = config.appId;
                        this._defaultPayload.sn = config.provider;
                        this._defaultHost = "".concat((0, remote_config_1.getString)(this._remoteConfig, "backend"));
                        if (typeof __BACKEND_HOST__ !== "undefined" && __BACKEND_HOST__) {
                            this._defaultHost = __BACKEND_HOST__;
                        }
                        this._defaultHost = this._defaultHost.replace(/\/+$/, "");
                        utils_1.log.info("defaultHost", this._defaultHost);
                        return [2];
                }
            });
        });
    };
    AppModel.prototype.getAuthorizationHeader = function () {
        if (this.signature) {
            return "Bearer ".concat(this.signature);
        }
        return _super.prototype.getAuthorizationHeader.call(this);
    };
    Object.defineProperty(AppModel.prototype, "firebaseApp", {
        get: function () {
            return this._firebaseApp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppModel.prototype, "defaultEndpoint", {
        get: function () {
            return "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppModel.prototype, "remoteConfig", {
        get: function () {
            return this._remoteConfig;
        },
        enumerable: false,
        configurable: true
    });
    AppModel.prototype.getDefaultRemoteConfig = function (backend) {
        if (backend === void 0) { backend = "http://localhost"; }
        return {
            backend: backend,
            payments_backend_url: "".concat(backend, "/purchase")
        };
    };
    AppModel = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], AppModel);
    return AppModel;
}(BackendModel_1.BackendModel));
exports.AppModel = AppModel;
//# sourceMappingURL=AppModel.js.map